// extracted by mini-css-extract-plugin
export default {"MainContainer":"style_MainContainer__t8eQI","NotFound":"style_NotFound__jAMc5"};